import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { NOTIFY } from "../../based/Constants";
import { ConfirmDialog } from "../../based/Dialog";
import { Notify } from "../../based/Notify";
import ArtistServices from "../../based/services/ArtistServices";
import ModalAddArtwork from "../components/ModalAddArtwork";
import Request from "../../based/Request";
import { CONSTANTS } from "../../based/Constants";
import MultipleImages from "../../based/MultipleImages";

const OBJShow = {
    id: -1,
};
const PAGING_ART = {
    pageSize: 1000000,
    pageNumber: 1,
    keyword: "",
};

export const FolderType = {
    Artwork: 1,
    Video: 2,
};

const modelArtwork = {
    name: "",
    id: 0,
    url: "",
    isDelete: false,
    folderId: 0,
};

function ArtworkDesktop() {
    const [isModal, setIsModal] = useState(false);
    const [dataFolder, setDataFolder] = useState([]);
    const [activeItem, setActiveItem] = useState(-1);
    const [dataArtwork, setDataArtwork] = useState([]);
    const [dataArt, setDataArt] = useState([]);
    const width = window.innerWidth;
    const [loading, setLoading] = useState(false);
    const [isVideo, setIsVideo] = useState(false);

    useEffect(() => {
        getDataFolder();
    }, []);

    const getDataFolder = async () => {
        setLoading(true);
        let [err, data] = await ArtistServices.GetFolderArtistAndArtworkByUser();
        if (!err && data && data.length > 0) {
            setDataFolder(data);
            setActiveItem(-1);
            setLoading(false);
        } else {
            setDataFolder([]);
            setActiveItem(-1);
            setLoading(false);
        }
    };

    const getArtworkByFolderId = async (folderId, handleRemove) => {
        setLoading(true);
        let [err, data] = await ArtistServices.GetArtworkByFolderId(folderId, PAGING_ART);
        if (!err && data && data.length > 0) {
            setDataArtwork(data);
            setLoading(false);
        } else {
            setDataArtwork([]);
            setLoading(false);
        }
        if (data && handleRemove) {
            let newDT = [...dataFolder];
            dataFolder.forEach((item, idx) => {
                if (item.id == folderId) {
                    newDT[idx].artworks = data;
                    newDT[idx].quantityArtwork = data.length;
                }
            });
            setDataFolder(newDT);
        }
    };

    useEffect(() => {
        let col = 3;
        if (width > 1024) col = 4;
        if (activeItem != -1) {
            let idex;
            dataFolder.forEach((item, idx) => {
                if (item.id == activeItem) idex = idx;
            });
            const idx = col - (idex % col) + idex;
            setDataFolder((prevList) => [...prevList.slice(0, idx), OBJShow, ...prevList.slice(idx)]);
        } else {
            resetData();
        }
    }, [activeItem]);

    const resetData = () => {
        let datanew = dataFolder.filter((x) => x.id != -1);
        setDataFolder(datanew);
    };
    const render = () => {
        return dataFolder.map((item, i) => {
            if (item.id == -1) {
                return renderArtwork();
            } else
                return (
                    <div key={i} className={`col ${activeItem == item.id ? "active" : ""}`}>
                        <div
                            className="item"
                            onClick={() => {
                                setIsVideo(item.folderType == FolderType.Video);
                                resetData();
                                if (activeItem == item.id) {
                                    setActiveItem(-1);
                                    setDataArtwork([]);
                                } else {
                                    setDataArtwork([]);
                                    getArtworkByFolderId(item.id, false);
                                    setActiveItem(item.id);
                                }
                            }}
                        >
                            <div className="show">
                                {item.artworks && item.artworks.length > 0 ? (
                                    item.artworks.length >= 2 ? (
                                        <div className="image">
                                            <div className="item-image">
                                                {item.folderType == FolderType.Video ? (
                                                    <video>
                                                        <source src={item.artworks[0].url} type="video/mp4" />
                                                    </video>
                                                ) : (
                                                    <img src={item.artworks[0].url} alt="alt" />
                                                )}
                                            </div>
                                            <div className="item-image">
                                                {item.folderType == FolderType.Video ? (
                                                    <video>
                                                        <source src={item.artworks[1].url} type="video/mp4" />
                                                    </video>
                                                ) : (
                                                    <img src={item.artworks[1].url} alt="alt" />
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="image">
                                            <div className="item-image">
                                                {item.folderType == FolderType.Video ? (
                                                    <video>
                                                        <source src={item.artworks[0].url} type="video/mp4" />
                                                    </video>
                                                ) : (
                                                    <img src={item.artworks[0].url} alt="alt" />
                                                )}
                                            </div>
                                        </div>
                                    )
                                ) : (
                                    <div className="image">
                                        <div className="item-image no-image"></div>
                                        <div className="item-image no-image"></div>
                                    </div>
                                )}
                                <div className="desc">{item.name}</div>
                                <div className="quantity">{item.quantityArtwork}</div>
                            </div>
                        </div>
                    </div>
                );
        });
    };

    const renderArtwork = () => {
        return (
            <div className="list-artwork">
                <div className="list-art">
                    <div className="row-art">
                        {/* <div className="col-art hidden-btn">
                            <button className="btn-add">
                                <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="23" cy="23" r="23" fill="#06F1B9"/>
                                    <path d="M23.4 14V32" stroke="white" stroke-width="2" stroke-linecap="round"/>
                                    <path d="M31.8 23L15 23" stroke="white" stroke-width="2" stroke-linecap="round"/>
                                </svg>
                            </button>
                        </div> */}
                        {dataArtwork && dataArtwork.length > 0 ? (
                            dataArtwork.map((item, idx) => {
                                return (
                                    <div key={idx} className={`col-art ${isVideo ? "video" : ""}`}>
                                        <ArtworkItem item={item} getArtworkByFolderId={getArtworkByFolderId} folderId={activeItem} isVideo={isVideo} />
                                    </div>
                                );
                            })
                        ) : (
                            <div className="col-art no-artwork">
                                <div className="artwork-zero">
                                    <div className="box"></div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };
    async function handleChange(value) {
        let data = [];
        if (value && value.length > 0) {
            value.map((img) => {
                var existed = dataArt.find((x) => x.url == img);
                if (!existed) {
                    var item = {
                        ...modelArtwork,
                        url: img,
                        thumbnail: img,
                    };
                    data.push(item);
                }
            });
        }
        await setDataArt([...dataArt, ...data]);
        openModal();
    }

    function openModal() {
        setIsModal(true);
    }

    return (
        <ArtworkDesktopStyle>
            <div className="title-artist">
                <h2>Artwork</h2>
                {dataFolder.length > 0 && (
                    <div>
                        <MultipleImages className="hide" id="art-work-desktop" name="art-desktop" size={20} images={[]} onChanged={(key, value) => handleChange(value)} />

                        <label for="art-work-desktop"> {activeItem == -1 ? "Tải lên" : "Thêm artwork"}</label>
                    </div>
                )}
            </div>
            <div className="list-folder">
                {render()}
                {dataFolder.length == 0 && <span className="desc-nofolder">Chưa có folder , liên hệ với Ranus để được tạo folder nhé !</span>}
            </div>
            {isModal && <ModalAddArtwork setDataArt={setDataArt} dataArt={dataArt} isModal={isModal} folderId={isVideo ? -1 : activeItem} setIsModal={setIsModal} getDataFolder={getDataFolder} />}
        </ArtworkDesktopStyle>
    );
}

function ArtworkItem({ item, getArtworkByFolderId, folderId, isVideo }) {
    const [isUpdate, setIsUpdate] = useState(false);
    const [itemUpdate, setItemUpdate] = useState(item);

    async function handleChange() {
        if (!itemUpdate.name) {
            Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Không để trống");
        } else {
            let [err, data] = await ArtistServices.CreateOrUpdateArkwork({
                ...itemUpdate,
            });
            if (!err && data == 1) {
                setIsUpdate(false);
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Thành công");
            } else {
                if (data == -2) {
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Đã tồn tại");
                } else {
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Thất bại");
                }
            }
        }
    }

    function handleDeleteArtwork() {
        const ids = [];
        ids.push(item.id);
        ConfirmDialog("Xác nhận xóa?", "Bạn có chắc chắn muốn xóa artwork này?", () => {
            return new Promise(async (resolve, reject) => {
                let [err, data] = await ArtistServices.DeteleFolderArtistCon(ids, folderId);
                if (!err && data) {
                    getArtworkByFolderId(folderId, true);
                    resolve({ title: "Thành công", msg: "Xóa thành công." });
                } else {
                }
            });
        });
    }
    if (isVideo)
        return (
            <div className="item-art video">
                <video controls>
                    <source src={item.url} type="video/mp4" />
                </video>
            </div>
        );
    return (
        <div className="item-art">
            <div className="image-art">
                <img src={item.url} />
            </div>
            <div className="box-art">
                <textarea
                    type="text"
                    maxLength={120}
                    disabled={isUpdate ? "" : "disabled"}
                    onChange={(e) => {
                        setItemUpdate({ ...itemUpdate, name: e.target.value });
                    }}
                    value={itemUpdate.name}
                />
                <div className="action-art">
                    {isUpdate && (
                        <span
                            onClick={() => {
                                setIsUpdate(false);
                            }}
                        >
                            Hủy
                        </span>
                    )}
                    <span
                        onClick={() => {
                            if (!isUpdate) setIsUpdate(true);
                            else {
                                handleChange();
                            }
                        }}
                    >
                        {isUpdate ? "Lưu" : "Đổi tên"}
                    </span>
                    <span onClick={handleDeleteArtwork}>Xóa</span>
                </div>
            </div>
        </div>
    );
}

const ArtworkDesktopStyle = styled.div`
    width: 100%;
    padding: 0 24px;

    .ml-18 {
        margin-left: 18px;
    }

    .hide {
        display: none;
    }

    .list-folder {
        margin: 29px -8px 0;
        display: flex;
        flex-wrap: wrap;

        .desc-nofolder {
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            color: #06f1b9;
            margin-top: 10px;
            display: block;
        }

        .list-artwork {
            padding: 0 8px;
            flex-basis: 100%;
            margin-bottom: 10px;
            min-width: 100%;
            max-width: 100%;
            margin-top: -12px;

            .list-art {
                background-color: #464646;
                border-radius: 0 0 10px 10px;
                border: 2px solid #06f1b9;
                padding: 20px 20px 5px 20px;

                .row-art {
                    display: flex;
                    flex-wrap: wrap;
                    margin: 0 -12px;

                    .col-art {
                        padding: 0 12px;
                        flex-basis: 50%;
                        margin-bottom: 15px;
                        min-width: 50%;
                        max-width: 50%;

                    

                        &.no-artwork {
                            .artwork-zero {
                                width: 100%;
                                .box {
                                    width: 35%;
                                    min-width: 35%;
                                    max-width: 35%;
                                    aspect-ratio: 1/1;
                                }
                            }
                        }

                        &.hidden-btn {
                            display: none;
                        }

                        .btn-add {
                            width: 100%;
                            border-radius: 5px;
                            place-items: center;
                            display: grid;
                            background-color: transparent;
                            border: 2px solid #06f1b9;
                            height: 100%;
                            cursor: pointer;
                        }

                        .item-art {
                            width: 100%;
                            background: #3a3a3a;
                            border-radius: 5px;
                            cursor: pointer;
                            aspect-ratio: 100/35;
                            position: relative;

                            &.video{
                                width: 100%;
                                aspect-ratio: unset;

                                video {
                                    width: 100%;
                                    min-width: 100%;
                                    max-width: 100%;
                                    display: inline-block;
                                   
                                }
                            }

                            

                            .image-art {
                                width: 35%;
                                min-width: 35%;
                                max-width: 35%;
                                aspect-ratio: 1/1;
                                display: inline-block;
                                padding: 7px;
                                position: absolute;
                                top: 0;
                                left: 0;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                    border-radius: 5px;
                                }
                            }

                            .box-art {
                                width: 65%;
                                min-width: 65%;
                                max-width: 65%;
                                display: inline-block;
                                aspect-ratio: 65/35;
                                padding: 7px 7px 7px 9px;
                                position: absolute;
                                top: 0;
                                left: calc(30% + 16px);

                                textarea {
                                    font-weight: 400;
                                    font-size: 14px;
                                    line-height: 18px;
                                    letter-spacing: -0.3px;
                                    color: #ffffff;
                                    background-color: transparent;
                                    border: none;
                                    outline: none;
                                    border-radius: 5px;
                                    width: 100%;
                                    height: calc(100% - 30px);

                                    :enabled {
                                        background-color: #464646;
                                    }
                                }
                                .action-art {
                                    text-align: right;

                                    span {
                                        font-weight: 500;
                                        font-size: 14px;
                                        line-height: 18px;
                                        letter-spacing: -0.3px;
                                        color: #06f1b9;
                                        margin-left: 12px;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .col {
            padding: 0 8px;
            flex-basis: 33.333%;
            margin-bottom: 10px;
            min-width: 33.333%;
            max-width: 33.333%;

            &.active {
                .item {
                    border-radius: 10px 10px 0 0;
                    border-top: 2px solid;
                    border-left: 2px solid;
                    border-right: 2px solid;
                    border-color: #06f1b9;
                    padding-bottom: 12px;
                }
            }

            .item {
                width: 100%;
                border-radius: 10px;
                background-color: #464646;
                cursor: pointer;

                .show {
                    padding: 10px;

                    .image {
                        display: flex;
                        justify-content: space-between;
                        width: 100%;

                        .item-image {
                            width: calc(50% - 5px);
                            line-height: 1;
                            aspect-ratio: 1/1;

                            &.no-image {
                                aspect-ratio: 1/1;
                            }

                            img {
                                width: 100%;
                                aspect-ratio: 1/1;
                                object-fit: contain;
                                border-radius: 5px;
                            }

                            video {
                                width: 100%;
                                aspect-ratio: 1/1;
                                border-radius: 5px;
                            }
                        }
                    }

                    .desc {
                        margin-top: 10px;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 18px;
                        letter-spacing: -0.3px;
                        color: #ffffff;
                    }
                    .quantity {
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 15px;
                        letter-spacing: -0.3px;
                        color: #9a9a9a;
                    }
                }
            }
        }
    }

    .title-artist {
        display: flex;
        align-items: center;
        justify-content: space-between;
        h2 {
            font-weight: 600;
            font-size: 25px;
            line-height: 31px;
            letter-spacing: -0.3px;
            color: #ffffff;
        }
        label {
            width: 180px;
            height: 46px;
            background: linear-gradient(259.14deg, #06f1b9 1.32%, #008263 100%);
            border-radius: 10px;
            display: grid;
            place-items: center;
            font-weight: 600;
            font-size: 18px;
            line-height: 20px;
            letter-spacing: -0.3px;
            color: #ffffff;
            border: none;
            outline: none;
            cursor: pointer;
        }
    }

    @media only screen and (device-width: 1024px) and (device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
        .item-art {
            aspect-ratio: 100/40 !important;
        }
    }

    @media (min-width: 1025px) {
        .list-folder {
            .list-artwork {
                .list-art {
                    .row-art {
                        .col-art {
                            flex-basis: 33.3333%;
                            min-width: 33.3333%;
                            max-width: 33.3333%;

                            &.hidden-btn {
                                display: block;
                            }
                        }
                    }
                }
            }
            .col {
                flex-basis: 25%;
                min-width: 25%;
                max-width: 25%;
            }
        }
    }
`;
export default ArtworkDesktop;



// WEBPACK FOOTER //
// ./src/artist-ui/Artwork/ArtworkDesktop.js